import ISO8601 from '@square/dashboard-data/models/squareup/bills/iso8601-date';
import TokenPair from '@square/dashboard-data/models/squareup/common/token/token-pair';
import { attr, ProtoBaseModel, repeated } from '@square/dashboard-data/utils/ember-model-stubs';
import MoneyProto from '@square/dashboard-data/models/squareup/common/money-proto';
import { Itemization } from '@square/dashboard-protos/models/squareup/bills/cart';
const {
  Type
} = Itemization.FeatureDetails.Seating.Destination;
const Destination = ProtoBaseModel.extend({
  createdAt: attr(ISO8601),
  seatTokenPair: repeated(TokenPair),
  type: attr(Type)
});
export const Seating = ProtoBaseModel.extend({
  destination: attr(Destination)
});
export const LineItemSplitDetailsPricing = ProtoBaseModel.extend({
  basePriceMoney: attr(MoneyProto),
  grossSalesMoney: attr(MoneyProto),
  originalQuantity: attr(String)
});
export const LineItemSplitDetails = ProtoBaseModel.extend({
  splitId: attr(String),
  splitPartNumber: attr(Number),
  splitTotalParts: attr(Number),
  originalLineItemPricing: attr(LineItemSplitDetailsPricing)
});
const ItemizationFeatureDetails = ProtoBaseModel.extend({
  seating: attr(Seating),
  lineItemSplitDetails: attr(LineItemSplitDetails)
});
export default ItemizationFeatureDetails;